import { combineReducers } from '@reduxjs/toolkit'
import gameSetting from './slices/gameSettings.slice'
import authSlice from './slices/auth.slice'
import kenoGame from 'games/Keno/slice-thunk/kenoGame.slice'
import crashGame from 'games/CrashGames/slice-thunk/crashGame.slice'
import pyramidPlinkoGame from 'games/Plinko/slices-thunks/pyramidPlinkoGame.slice'
import mineGame from 'games/Mines/slices-thunks/mineGame.slice'
import diceGame from 'games/Dice/slices-thunks/diceGame.slice'
import diceStrategy from 'games/Dice/slices-thunks/diceStrategy.slice'
import hiLoGame from 'games/HiLo/slice-thunk/hiLoGame.slice'
import flipCoinGame from 'games/FlipCoin/slice-thunk/flipCoinGame.slice'
import tapTapMineGame from 'games/Mines/slices-thunks/gongaMineGame.slice'
import bbCrossGame from 'games/BbCrossGame/slice-thunks/bbCrossGame.slice'
import towerGame from 'games/TowerGame/slice-thunk/towerGame.slice'
import SexyRushGame from 'games/SexyRush/slices-thunks/mineGame.slice'
import chat from './slices/chat.slice'

import loader from './slices/loader.slice'

const rootReducer = combineReducers({
  gameSetting,
  crashGame,
  kenoGame,
  hiLoGame,
  diceGame,
  mineGame,
  pyramidPlinkoGame,
  tapTapMineGame,
  diceStrategy,
  flipCoinGame,
  auth: authSlice,
  loader,
  chat,
  bbCrossGame,
  towerGame,
  SexyRushGame
})

export default rootReducer
